import React from 'react';
import './Loader.css';

const Loader = ({ size = 'medium', fullscreen = false }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  if (fullscreen) {
    return (
      <div className="loader-fullscreen">
        <div className={`loader ${sizeClasses[size]}`}></div>
      </div>
    );
  }

  return (
    <div className="loader-container">
      <div className={`loader ${sizeClasses[size]}`}></div>
    </div>
  );
};

export default Loader;
